export default __webpack_public_path__ + "static/media/myads.4e8a96b9.svg";